import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Me from '../images/personal-photo.jpg';
import WaveImg from '../images/wave.png';
import { setSidebarHidden } from '../actions/sidebar';
import RecentPosts from '../components/RecentPosts';
import TechExperience from '../components/TechExperience';
import media from '../util/media';

const MEASURE = '88ch';

const OuterContainer = styled.div`
  display: grid;
  grid-template-columns: [about] auto [photo] 500px;

  ${
    media.tablet`
      grid-template-columns: [about] auto [photo] 375px;
    `
  }

  ${
    media.phone`
      display: block;
    `
  }
`;

const Content = styled.div`
  grid-column: about;
  padding: 150px 50px 150px 50px;
  max-width: ${MEASURE};
  margin: 0 auto;
  overflow-x: hidden;

  ${
    media.phone`
      padding-top: 100px;
    `
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: rgba(0,0,0,.5);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
`;

const Headline = styled.h1`
  font-size: 84px;
`;

const Expertise = styled.p`
  margin: 0 0 30px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: ${props => props.theme.primaryColor};

  ${
    media.phone`
      font-size: 12px;
      letter-spacing: 1.2px;
    `
  }
`;

const SideContent = styled.div`
  position: sticky;
  top: 0;
  right: 0;
  grid-column: photo;
  background-color: ${props => props.theme.primaryColor};
  width: 100%;
  height: 100vh;

  ${
    media.phone`
      position: static;
      height: auto;
    `
  }
`;

const Photo = styled.img`
  width: 100%;
  box-sizing: border-box;
`;

const ContactWrapper = styled.div`
  display: flex;
  flex-flow: column-reverse;
  width: 500px;

  ${
    media.tablet`
      width: 375px;
    `
  }

  ${
    media.phone`
      position: static;
      height: auto;
    `
  }
`;

const Contact = styled.div`
  width: 100%;
  padding: 50px;
  margin-bottom: 50px;
  color: white;
  background-color: ${props => props.theme.primaryColor};
  box-sizing: border-box;
`;

const Social = styled.div`
  margin-top: 20px;

  > * {
    margin: 0 20px 20px 0;
    font-size: 30px;
    color: white;
  }
`;

const Wave = styled.img`
  width: 75px;
`;

const Email = styled.a`
  text-decoration: none;
  font-family: "Playfair Display", serif;
  font-weight: 500;
  color: inherit;
`;

const Location = styled.p`
  font-size: 14px;
  letter-spacing: 0.3px;
  color: rgba(0, 0, 0, 0.45);
`;


class Home extends React.PureComponent{
  componentDidMount() {
    this.props.dispatch(setSidebarHidden(false));
  }

  render() {
    return (
      <OuterContainer>
        <Content>
          <Headline>Hi, I'm Robin <Wave src={WaveImg} alt="wave" /></Headline>
          <h2>Software Engineer & Entrepreneur</h2>
          <Expertise>System Design · Software Architecture · Developer Experience</Expertise>
          <p>I help teams build durable software and reduce the technical risk that's slowing them down. I take a limited number of client engagements, ranging from short architecture reviews and technical advisory to hands-on implementation.</p>
          <p>Need senior technical judgement, engineering leadership, or help with a complex problem? Get in touch at <a href="mailto:contact@robinsiep.com">contact@robinsiep.com</a>.</p>
          <Location>Based in the Netherlands · working with clients worldwide</Location>
          <h3>Services</h3>
          <ul>
            <li>Architecture and system design</li>
            <li>Backend and distributed systems engineering</li>
            <li>Web and mobile client development</li>
            <li>Cloud infrastructure, CI/CD and operational architecture</li>
            <li>Security-aware design and threat-modelling</li>
            <li>Technical strategy, architecture reviews and senior advisory</li>
          </ul>
          <h3>Key technologies</h3>
          <TechExperience />
          <RecentPosts endpoint={`${window.__CONFIG__?.blogDomain ?? "https://robinsiep.com"}/blog-jsonrss/recent-posts`} />
        </Content>
        <SideContent>
          <Photo src={Me} alt="Robin" />
          <ContactWrapper>
            <Contact>
              <h1>Get in touch</h1>
              <Email href="mailto:contact@robinsiep.com"><h2>contact@robinsiep.com</h2></Email>
              <Social>
                <a href="https://github.com/RobinSiep"><i className="fab fa-github"></i></a>
                <a href="https://www.linkedin.com/in/robin-siep-6b464985"><i className="fab fa-linkedin"></i></a>
              </Social>
            </Contact>
          </ContactWrapper>
        </SideContent>
      </OuterContainer>
    );
  }
}

export default connect()(Home);
